const SupportCasesEndpointFetchAllRequestHttpQueryParams = (request) => {
    return {
        patient_id: request.patient_id,
        page_size: request.pagination?.page_size,
        page_token: request.pagination?.page_token,
    };
};
export const SupportCasesEndpoint = (makeRequest) => {
    return {
        // Fetch one Support Case given the support case ID
        fetchOne(params, options) {
            const { id, ...query } = params;
            return makeRequest('GET', `/v1/support_cases/${id}`, query, options);
        },
        // Fetch all Support Cases for a given patient
        fetchAll(params, options) {
            return makeRequest('GET', '/v1/support_cases', SupportCasesEndpointFetchAllRequestHttpQueryParams(params), options);
        },
        // Check if a given patient is an eligible Support Case patient
        supportCaseUserEligibility(params, options) {
            return makeRequest('GET', '/v1/support_cases/support_case_user_eligibility', params, options);
        },
    };
};
//# sourceMappingURL=support_cases_endpoint.js.map